/*
 * chk-shogun-compat.js
 * ─────────────────────────────────────────────
 * Shogun製ページのスクロール出現アニメーション互換スクリプト（暫定措置）
 *
 * 【背景】
 * Shogunで作られた固定ページの本文には、スクロール出現アニメーション
 * （.fadeIn_item に .offs = opacity:0 を付け、スクロールに応じて .ons へ
 * 付け替える）がインラインJSとして埋め込まれている。この本体スクリプトは
 * $(window).scroll / $(window).scrollTop() で判定している。
 *
 * ところが Horizon はデスクトップ（≥990px）で <html> ではなく
 * .page-wrapper をスクロールコンテナにする（assets/base.css の
 * html:has(.page-wrapper){overflow:hidden} と assets/scroll-container.js）。
 * そのため window に scroll イベントが飛ばず scrollTop も常に 0 となり、
 * 初期表示に入っている要素しか出現しない（残りは透明のまま）。
 *
 * 【このスクリプトの役割】
 * デスクトップ幅のときだけ、.page-wrapper のスクロールを監視して
 * 「画面下から20%ぶん入った要素」を .ons にする。本体スクリプトの
 * scr_ani（wh_pos = 20）と同じしきい値。
 * モバイル幅（<990px）では本体スクリプトが正常に動くため何もしない。
 * 二重駆動を避けるための意図的な切り分け。
 *
 * 【設計上の注意（実装時に踏んだ問題）】
 * - IntersectionObserver 方式は不採用。読み込み直後は画像が未読込で
 *   全要素が画面内に重なるため一度に全件出現してしまい、その直後に
 *   本体の ready 処理（scr_ani(0, …)）が画面外の要素へ .offs を付け直す。
 *   IO は「交差状態が変化したとき」しか発火しないため、付け直された要素が
 *   画面内に留まったままだと二度と出現しなくなる（実際に発生）。
 * - そのため毎スクロールで対象全件を評価する総当たり方式にしている。
 *   対象は十数件程度、rAFで間引くため負荷は無視できる。
 * - 出現のみ行い、スクロールを戻したときの再非表示は行わない。
 * - window に合成 scroll イベントを飛ばす方式は、Horizon本体や他アプリの
 *   スクロール監視に影響するため採用しない。
 * - Horizonの既存ファイル・既存JSには一切手を入れていない。
 *
 * 【将来の削除】
 * Shogun製ページをHorizonへ移行し終えたら、chk-jquery.min.js と合わせて
 * このファイルと snippets/chk-head.liquid の読み込み記述を削除する。
 * ─────────────────────────────────────────────
 */
(function () {
  'use strict';

  var SQUEEZE_QUERY = '(min-width: 990px)';
  var TRIGGER_RATIO = 0.2; // 本体スクリプトの wh_pos = 20（%）と同じ

  var items = [];
  var scroller = null;
  var ticking = false;

  function show(el) {
    el.classList.remove('offs');
    el.classList.add('ons');
  }

  /* 画面内（しきい値より上）に入っている要素をすべて出現させる */
  function sweep() {
    ticking = false;

    var bottom;
    var height;
    if (scroller) {
      var rect = scroller.getBoundingClientRect();
      bottom = rect.bottom;
      height = rect.height;
    } else {
      bottom = window.innerHeight;
      height = window.innerHeight;
    }
    var line = bottom - height * TRIGGER_RATIO;

    for (var i = 0; i < items.length; i++) {
      if (items[i].getBoundingClientRect().top < line) show(items[i]);
    }
  }

  /* 評価を次の描画フレームまで間引く。
     ※非表示タブでは requestAnimationFrame が発火しないため、
       setTimeout の保険を必ず併用する。これが無いと ticking が立ったままになり、
       以後のスクロールが一切評価されなくなる（バックグラウンドタブで発生）。
       sweep は冪等なので二重に走っても問題ない。 */
  function request() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(sweep);
    window.setTimeout(function () {
      if (ticking) sweep();
    }, 200);
  }

  function init() {
    // モバイル幅では本体スクリプト（jQuery側）が機能するので介入しない
    if (!window.matchMedia(SQUEEZE_QUERY).matches) return;

    // .offs が後から付け直されても拾えるよう、対象は .fadeIn_item 全件
    items = Array.prototype.slice.call(document.querySelectorAll('.fadeIn_item'));
    if (!items.length) return;

    scroller = document.querySelector('.page-wrapper');
    (scroller || window).addEventListener('scroll', request, { passive: true });
    window.addEventListener('resize', request, { passive: true });

    // 画像読み込みでレイアウトが動くため、load後にもう一度評価する
    window.addEventListener('load', request);

    // 非表示タブで読み込まれた場合に備え、表示に戻ったタイミングでも評価する
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') request();
    });

    request();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
